export const m = {
  common: {
    t1: "Experience demo",
    t2: "Interactive Directory System (IDS)",
    t3: "Static Directory System (SDS)",
    t4: "Multimedia Information Display System (MIDS)",
    t5: "Car Search Payment System (CSPS)",
    t6: "Indoor Navigation System (INS)",
    t7: "AR Navigation System (AR)",
    t8: "Easy2walk",
    t9: "Easylease",
    t10: "Learn more",
    t11: "Appointment demonstration",
    t12: "Consultants",
    t13: "Shopping Mall",
    t14: "Hospital",
    t15: "Office Building",
    t16: "Traffic",
    t17: "Education",
    t18: "Watch Video",
    t19: "Main",
    t20: "Product",
    t21: "Solution",
    t22: "About us",
    t23: "basic products",
    t24: "application products",
    t25: "language",
    t26: "Contact us",
    t27: "Company profile",
    t28: "News Center",
    t29: "Hardware products",
    t30: 'Self service machine CKIOSK C1',
    t31: 'Self service machine CKIOSK C2',
    t32: 'Self service machine CKIOSK D1',
    t33: 'Operation maintenance monitor CKIOSK M1',
    taxtData: [
      {
        title: "3D map",
        url: "static/window/ids/icon1.png",
        html: ` locating where you are on a 3D map which can rotate and <br>zoomed in and out lets you know better your whereabouts.`,
        html1: ` locating where you are on a 3D map which can rotate and zoomed in and out lets you know better your whereabouts. `
      },
      {
        title: "Current location",
        url: "static/window/ids/icon2.png",
        html: `the map automatically routes to where the user is facing<br> for easier understanding and reading of the map.`,
        html1: `the map automatically routes to where the user is facing for easier understanding and reading of the map.`
      },
      {
        title: "Best route",
        url: "static/window/ids/icon3.png",
        html: `system always finds the best route for you <br> and estimate the time cost`,
        html1: `system always finds the best route for you and estimate the time cost`
      },
      {
        title: "Accessible route",
        url: "static/window/ids/icon4.png",
        html: `users can choose lift as preferred route <br> for accessible route`,
        html1: `users can choose lift as preferred route for accessible route`
      },
      {
        title: "Height adjustment",
        url: "static/window/ids/icon5.png",
        html: ` users can access the buttons on the top <br> with lowered mode`,
        html1: ` users can access the buttons on the top with lowered mode`
      },
      {
        title: "Equipment search",
        url: "static/window/ids/icon6.png",
        html: `users can search the most common facilities <br> and equipments on a single click. `,
        html1: `users can search the most common facilities and equipments on a single click. `
      },
      {
        title: "Multi language",
        url: "static/window/ids/icon7.png",
        html: ` the system supports over 20 languages,<br> catering to every user. `,
        html1: ` the system supports over 20 languages, catering to every user. `
      },
      {
        title: "Keyword search",
        url: "static/window/ids/icon8.png",
        html: `customers can search products, brands and  <br>services in the search bar`,
        html1: `customers can search products, brands and services in the search bar`
      },
      {
        title: "Car-finding",
        url: "static/window/ids/icon9.png",
        html: `users can find the whereabouts of there car <br> with flexible integrated system.`,
        html1: `users can find the whereabouts of there car with flexible integrated system.`
      },
      {
        title: "Smart Ad",
        url: "static/window/ids/icon10.png",
        html: `by displaying dynamic media content (including high-resolution video, images or Adobe®Flash® animation), the displays attract users' attention`,
        html1: `by displaying dynamic media content (including high-resolution video, images or Adobe®Flash® animation), the displays attract users' attention`
      },
      {
        title: "User feedback",
        url: "static/window/ids/icon11.png",
        html: `user can write their feedback to help better <br> improve the service and experience`,
        html1: `user can write their feedback to help better improve the service and experience`
      },
      {
        title: "Scan and go",
        url: "static/window/ids/icon12.png",
        html: `user can scan QR codes to send the routes to their mobile to achieve real-time navigation via Bluetooth navigation system. `,
        html1: `user can scan QR codes to send the routes to their mobile to achieve real-time navigation via Bluetooth navigation system. `
      }
    ]
  },
  home: {
    t1: "Digitalized Indoor Directory Experience",
    t2: `World's Leading Indoor Map Solution Provider`,
    t3: "User-Focused Directory Experience For All Occasions",
    t4:
      "Chaunve is an overall solution provider from surveying, visual design, data collection, modeling to digitized product development and implementation, helping enterprises implement digital transformation and enhance user experiences.",
    productData: [
      {
        navUrl: "./static/window/product/icon0.png",
        bgUrl: "static/window/home/1.png",
        cName: "one map",
        eName: "",
        shortName: "",
        codeUrl: "",
        link: "onemap",
        des: `With the help of online mapping tool cmappax, a business intelligence system is built up for data collection, calculation and processing. All data is stored with unified standard as company asset for the better analysis and review in the future.<br> 
        With fully flexible API, the data is interconnectable to all systems, building up a comprehensive "one map" system with products of Chaunve. It solves the problem of originally scattered data and truly realizes a integrated system. `
      },
      {
        navUrl: "./static/window/product/icon1.png",
        bgUrl: "static/window/home/2.png",
        cName: "Interactive Dictionary System",
        eName: "Interactive Dictionary System",
        shortName: "IDS",
        codeUrl: "",
        link: "ids",
        des: `Chaunve's interactive directory system (IDS) is a breakthrough of the traditional signage system, integrating interactive functions, intelligence and experiential elements into one system. The integrated IDS provides services of way-finding, shopping directory, advertisement, entertainment, information release, contact, car-finding and parking payment, VIP services, etc. The system meets the ever changing needs of customers to fulfill their enquiries on information in need, greatly alleviating the pressure of concierge. The system, with the state-of-art audiovisual and touch experiences, bridges property owners and customers in a creative, dynamic way for efficient communication. `
      },
      {
        navUrl: "./static/window/product/icon2.png",
        bgUrl: "static/window/home/3.png",
        cName: "Static Directory System",
        eName: "Static Directory System",
        shortName: "SDS",
        codeUrl: "",
        link: "sds",
        des: `The system can be based on internet or intranet leveraging on the technology of touch screen, display, sensors to display information of overall directory or floor directory in real time. Operators can manage the contents via backend simultaneously. When no customers are detected nearby, advertisements are aired while customers come near, the display will automatically change to directory contents with the help of a sensor. The system changes the traditional way of updating contents on-site manually and hence high manpower cost and low efficiency. `
      },
      {
        navUrl: "./static/window/product/icon3.png",
        bgUrl: "static/window/home/4.png",
        cName: "Multimedia Information Display System",
        eName: "Multimedia Information Display System",
        shortName: "MIDS",
        codeUrl: "",
        link: "mids",
        des: `MIDS can be internet or intranet based for multimedia contents display. This caters to government, enterprises, hospitals, banks, transportation, schools, buildings, shops, malls, hotels, restaurants, outlets or chain organisations to build a multimedia information release platform with screens to display contents of videos, pictures, text, webpage, APP, WeChat, etc. The system provides customers with an easy way of content management with cloud based service at low cost. The system enables operators to manage and arrange the playlist to their preference anytime via cloud. Manpower cost is saved for on-site content update by the new smart content management backend. `
      },
      {
        navUrl: "./static/window/product/icon4.png",
        bgUrl: "static/window/home/5.png",
        cName: "Car Search Payment System",
        eName: "Car Search Payment System",
        shortName: "CSPS",
        codeUrl: "",
        link: "csps",
        des: `Car Search Payment System (CSPS) is an integrated car park management system that provides services of car-finding, parking fee payment with 7/24 access. 
        The system has a LED touch screen as user end and supports face identification for car-finding, car-finding by car plate or lot number. The system also supports parking fee settlement with QR code, face identification, etc. The system is fully automatic and user-friendly which can replace traditional human duty of parking fee settlement. Especially for large-scale parking lots, the CSPS greatly increases the management efficiency and lowers manpower costs, also improving property management levels.`
      },
      {
        navUrl: "./static/window/product/icon5.png",
        bgUrl: "static/window/home/6.png",
        cName: "Indoor Navigation System",
        eName: "Indoor Navigation System",
        shortName: "INS",
        codeUrl: "",
        link: "indoor",
        des: `The system is based on the map engine developed and patented by Chaunve. With integration to systems of WiFi, Bluetooth, UWB and others, INS helps user to locate destination efficiently. INS is adaptable to a variety of accuracy requirements and suitable for different industries'users. `
      },
      {
        navUrl: "./static/window/product/icon6.png",
        bgUrl: "static/window/home/7.png",
        cName: "AR Navigation System",
        eName: "AR Navigation System",
        shortName: "AR",
        codeUrl: "",
        link: "ar",
        des: `By modelling on the actual physical world with AI visualisation abilities, AR navigation system can help customers to quickly navigate to its destination with advanced AI technology. The system also serves as a promotional platform for users. The implementation requires no on-site construction works and the navigation can be as accurate as 1m. `
      },
      {
        navUrl: "./static/window/product/icon9.png",
        bgUrl: "static/window/home/10.png",
        cName: "Business Intelligence System (BI)",
        eName: "Business Intelligence System (BI)",
        shortName: "",
        codeUrl: "",
        link: "bi",
        des: `Not restricted by geographic platform, allowing you to view data instantly anytime, anywhere
        Developed in HTML5，Data of updated in seconds, and you can immediately notice the latest situation on the spot, and can be viewed on different platforms at the same time, regardless of the geographical platform.<br>
        The indoor map is displayed and the user can simple and direct to select the data in the map and view. 
        The Business Intelligence System can relevant personnel assisted in manual operation while performing correlation analysis of data, and produced different analysis charts to fully display the process of data analysis and different data trends. `
      },

      {
        navUrl: "./static/window/product/icon10.png",
        bgUrl: "static/window/home/11.png",
        cName: "Advertisement Management System (ADS)",
        eName: "Advertisement System (ADS)",
        shortName: "",
        codeUrl: "",
        link: "ads",
        des: `Based on the digital map, an integrated system for visualized management of advertising space resources, online appointments, and online approvals for the entire scene (physical advertising spaces, electronic advertising screens, etc.) is established.`
      },
      {
        navUrl: "./static/window/product/icon7.png",
        bgUrl: "static/window/home/8.png",
        cName: "easy2walk",
        eName: "easy2walk",
        shortName: "",
        link: "easytowalk",
        codeUrl: "./static/window/product/easy2walkCode.png",
        des: `When new to a city with language or network barrier, easy2walk can help navigate to your brands or shops easily across all malls. The system also provides information of best route and even shopping recommendations.Easy2walk bridges you and your destination without thinking, asking or waiting in the easiest way.`
      },
      {
        navUrl: "./static/window/product/icon8.png",
        bgUrl: "static/window/home/9.png",
        cName: "easylease",
        eName: "easylease",
        shortName: "",
        codeUrl: "",
        link: "easylease",
        des: `Easylease is an online leasing system which enables leasing representatives to talk to potential clients virtually online without meeting in person. The platform is the best way to present all leasing materials online digitally including trade mix introduction, area size, leased areas, etc.<br>
        Easylease is also a smart platform for leasing representatives and clients to communicate with each other. Clients can easily get their answers online by enquiring on the platform to leasing representatives. `
      }
    ],
    t5: `Cmappax is a mapping tool developed independently by Chaunve, providing all-round functions from surveying, modelling, production with open API to other data source. The system supports customization of 2D/3D maps online with self-service editing and review online. Editing files and access rights can be managed and saved online anytime. `,
    t5_mobile:
      "Cmappax is a mapping tool developed independently by Chaunve, providing all-round functions from surveying, modelling, production with open API to other data source. The system supports customization of 2D/3D maps online with self-service editing and review online. Editing files and access rights can be managed and saved online anytime. ",

    t6:
      "Chaunve deeply understands the importance of preliminary evaluation and continuous assessment throughout the implementation in project management from design, production and implementation. We also provides consulting services with our established experiences and records. Our consulting team is composed by experienced project holders, senior design and creative directors and senior IT directors. The consulting services covers preliminary assessment, evaluation and adjustment consulting for projects in construction and revamp suggestions for projects that area already in operation. A well-designed directory system can have fundamental influences to the project in its outlook as well as its operational successes. A successful directory system can not only bring new business opportunities but also improve brand image of the entire project. ",
    t7: "Customer testimony",
    t8: `We have clients from <span style='font-size: 0.32rem;' class="num">30</span> different cities from different industries in Mainland China and Hong Kong`,
    customerAppraiseData: [
      {
        title: "Wharf Group",
        des: `We are always looking for partners who are technologically advanced and in step with us. The advanced product technology of Chaunve is their core competitiveness. What's more, we appreciate the idea of "helping people" of Chaunve team. Every customized function and even the setting of each button are all based on customers, which is in line with our concept. We believe that dedicated and attentive supplier like Chaunve can deeply convey our service tenet to every customer's heart, which is what we value most.`,
        logoUrl: "./static/window/customAppraise/logo1.png"
      },
      {
        title: "Sun Hung Kai Group",
        des:
          "The timing of cooperation between Sun Hung Kai and Chaunve is just right. Onemap platform designed by them is the solution we have been looking for. It enables us to realize the unified management of the system map of the website,  WeChat official account, small program, IDS, reverse search vehicle and so on through one same backstage. Our operators can finally get rid of repeated modification and repeated communication with different suppliers, which solves a big problem for us. For the commercial real estate industry, the establishment of digital operation system is imperative, but also has a long way to go. In the future, we hope to have more innovative cooperation with Chaunve, and upgrade our projects to be more intelligent.",
        logoUrl: "./static/window/customAppraise/logo2.png"
      },
      {
        title: "Xiangya Hospita",
        des:
          "From the initial knowledge to the formal establishment of the cooperation process, every employee of Chaunve, including pre-sales, sales consultants, implementation specialists and after-sales treatment, are extremely professional. In addition, the submitted solutions reflect the professionalism of the solutions for the creative industry. Product performance, function, after-sales process, service are all endorsed by peers in the industry, which is highly praised. It is quite reassuring to give projects to service provider like them. ",
        logoUrl: "./static/window/customAppraise/logo3.png"
      },
      {
        title: "Excellence Group",
        des:
          "When it comes to select partners, our team spent a lot of time to carefully compare several domestic and foreign brands, and finally chose Chaunve. The reason is that they are the first domestic software and hardware manufacturers to develop interactive guide system, and so far they are still in the lead of business solutions. The implementation of the new retail strategy requires a partner with rich industry experience and extreme innovation ability. We can both achieve long-term development in our cooperation.",
        logoUrl: "./static/window/customAppraise/logo4.png"
      }
    ],
    t9: "The customers we served",
    t10: "Learn more about other industry solutions"
  },
  m1: {
    t1: 'Enable smart upgrade of traditional equipment',
    t2: "Android deep customization system, stable and reliable<br />4G communication capability, enabling traditional equipment<br />Built in Bluetooth communication to realize<br />intelligent linkage of devices Real time collection of equipment working<br />condition data and on-site status<br />Enrich external interfaces and create more possibilities Mini size, flexible to different deployment environments",
    t2_mobile: "Android deep customization system, stable and reliable<br />4G communication capability, enabling traditional equipment<br />Built in Bluetooth communication to realize<br />intelligent linkage of devices Real time<br />collection of equipment working<br />condition data and on-site status<br />Enrich external interfaces and create more possibilities Mini size,<br />flexible to different deployment environments",
    t3: 'Application scenario',
    t4: 'Shopping centers, office buildings,hospitals,<br />schools,airports,high-speed railway stations, etc',
    t4_mobile: 'Inventor of 2D / 3D indoor map and navigation guidance system<br />(national invention patent No.: 201310272792.3)',
    t5: 'on-line',
    t6: 'Open the web page and you can draw',
    listData2: [
      {
        url: "./static/window/m1/jiance.png",
        title: "Power off monitoring"
      },
      {
        url: "./static/window/m1/kaiji.png",
        title: "Power on"
      },
      {
        url: "./static/window/m1/guanji.png",
        title: "Power off"
      },
      {
        url: "./static/window/m1/baohu.png",
        title: "Power off protection"
      }
    ],
    listData2_B: [
      {
        url: "./static/window/m1/kaiguan.png",
        title: "Timing switch"
      },
      {
        url: "./static/window/m1/kongzhi.png",
        title: "Screen control"
      },
      {
        url: "./static/window/m1/caiji.png",
        title: "Status acquisition"
      },
      {
        url: "./static/window/m1/yuanchen.png",
        title: "Remote control"
      }
    ],
    t7: 'technical specifications',
    listData3: [
      {
        url: "./static/window/m1/d1-xitong.png",
        title: "system",
        html: `Window 10`
      },
      {
        url: "./static/window/m1/d1-cpu.png",
        title: "CPU",
        html: `8-core 2G`
      },
      {
        url: "./static/window/m1/d1-chucun.png",
        title: "Store",
        html: `2G RAM 16GROM`
      },
      {
        url: "./static/window/m1/m1-dianchi.png",
        title: "Battery",
        html: `4000mAh`
      }, {
        url: "./static/window/m1/d1-Wi-Fi.png",
        title: "Wi-Fi",
        html: `support IEEE 802.11<br />a/b/g/n 2.4/5GHz`
      },
      {
        url: "./static/window/m1/d1-yitai.png",
        title: "Ethernet",
        html: `1个 10/100/1000M<br />self-adaption`
      },
      {
        url: "./static/window/m1/c1-4g.png",
        title: "4G network",
        html: `China Mobile, China Telecom, China Unicom`
      },
      {
        url: "./static/window/m1/d1-usb.png",
        title: "USB interface",
        html: `1×USB interface`
      }, {
        url: "./static/window/m1/d1-Wi-Fi.png",
        title: "wifi interface",
        html: `1×wifi interface`
      },
      {
        url: "./static/window/m1/c1-lanya.png",
        title: "Bluetooth",
        html: `1×bluetooth interface`
      },
      {
        url: "./static/window/m1/c1-jiekou.png",
        title: "RS232interface",
        html: `1xRS232interface`
      },
      {
        url: "./static/window/m1/d1-dianyuan.png",
        title: "Power Supply",
        html: `1 x DC Power Supply interface`
      }, {
        url: "./static/window/m1/d1-chicun.png",
        title: "size",
        html: `equipment25*115*156mm<br />packing27*117*158mm`
      },
      {
        url: "./static/window/m1/d1-zhongliang.png",
        title: "weight",
        html: `0.125Kg`
      },
      {
        url: "./static/window/m1/d1-shuchu.png",
        title: "Power input",
        html: `AC100~120V<br />AC200~240V`
      },
      {
        url: "./static/window/m1/d1-huanjing.png",
        title: "work environment",
        html: `working temperature：0 ~ 40℃<br />Storage temperature：-20℃ ~ 55℃`
      }
    ],
    listData3_mobile: [
      {
        url: "./static/window/mobileM1C1C2D1/xitong.png",
        title: "system",
        html: `Window 10`
      },
      {
        url: "./static/window/mobileM1C1C2D1/cpu.png",
        title: "CPU",
        html: `8-core 2G`
      },
      {
        url: "./static/window/mobileM1C1C2D1/chucun.png",
        title: "Store",
        html: `2G RAM <br />16GROM`
      },
      {
        url: "./static/window/mobileM1C1C2D1/dianchi.png",
        title: "Battery",
        html: `4000mAh`
      }, {
        url: "./static/window/mobileM1C1C2D1/wifi.png",
        title: "Wi-Fi",
        html: `support IEEE<br />802.11a/b/g<br />/n 2.4/5GHz`
      },
      {
        url: "./static/window/mobileM1C1C2D1/yitai.png",
        title: "Ethernet",
        html: `1个 10/100/1000M<br />self-adaption`
      },
      {
        url: "./static/window/mobileM1C1C2D1/4g.png",
        title: "4Gnetwork",
        html: `Mobile, Telecom,<br />Unicom`
      },
      {
        url: "./static/window/mobileM1C1C2D1/usb2.png",
        title: "USB Interface",
        html: `1×USB<br />Interface`
      }, {
        url: "./static/window/mobileM1C1C2D1/wifi.png",
        title: "Wi-Fi Interface",
        html: `1×wifi Interface`
      },
      {
        url: "./static/window/mobileM1C1C2D1/lanya.png",
        title: "Bluetooth",
        html: `1×bluetooth<br />interface`
      },
      {
        url: "./static/window/mobileM1C1C2D1/jiekou.png",
        title: "RS232 Interface",
        html: `RS232Interface`
      },
      {
        url: "./static/window/mobileM1C1C2D1/dianyuan.png",
        title: "Power Supply",
        html: `1 x DC Power<br />Supply Interface`
      }, {
        url: "./static/window/mobileM1C1C2D1/chicun.png",
        title: "size",
        html: `equipment25*115<br />*156mm packing<br />27*117*158<br />mm`
      },
      {
        url: "./static/window/mobileM1C1C2D1/zhongliang.png",
        title: "weight",
        html: `0.125Kg`
      },
      {
        url: "./static/window/mobileM1C1C2D1/shuru.png",
        title: "Power input",
        html: `AC100~120V<br />AC200~240V`
      },
      {
        url: "./static/window/mobileM1C1C2D1/huanjing.png",
        title: "work environment",
        html: `working temperature<br />0 ~40℃<br />Storage temperature<br />-20℃ ~ 55℃`
      }
    ],
  },
  c1: {
    t1: 'Standard Edition',
    t2: "Full HD camera<br />43 '4K full vision HD touch display integrated large screen<br />Domestic well-known directional noise reduction microphone<br />It adopts internationally renowned capacitive touch screen with fast response and high precision<br />Chanve OS provides services such as application market management, screen hegemony, remote<br />control, gray scale upgrading, etc",
    t2_mobile: "Full HD camera<br />43 '4K full vision HD touch display integrated large screen<br />Domestic well-known directional noise reduction microphone<br />It adopts internationally renowned capacitive touch screen<br />with fast response and highprecision Chanve OS provides<br />services such as application market management,screen<br />hegemony, remote control, gray scale upgrading, etc",
    t3: 'Application scenario',
    t4: 'Shopping centers, office buildings, hospitals, schools, airports, high-speed railway stations, etc',
    t4_mobile: 'Inventor of 2D / 3D indoor map and navigation guidance system<br />(national invention patent No.: 201310272792.3)',
    t5: 'on-line',
    t6: 'Open the web page and you can draw',
    listData2: [
      {
        url: "./static/window/c1/chumo.png",
        title: "Capacitive touch"
      },
      {
        url: "./static/window/c1/4k.png",
        title: "4K display"
      },
      {
        url: "./static/window/c1/tongji.png",
        title: "Usage statistics"
      },
      {
        url: "./static/window/c1/yuyin.png",
        title: "Voice service"
      }
    ],
    t7: 'technical specifications',
    listData3: [
      {
        url: "./static/window/m1/d1-xitong.png",
        title: "system",
        html: `Window 10`
      },
      {
        url: "./static/window/m1/d1-cpu.png",
        title: "CPU",
        html: `6-core 3.0G`
      },
      {
        url: "./static/window/m1/d1-chucun.png",
        title: "storage",
        html: `PCIE<br />SSD solid state disk 120g`
      },
      {
        url: "./static/window/m1/d1-neicun.png",
        title: "Memory",
        html: `DDR4 2133 8G`
      },
      {
        url: "./static/window/m1/c1-xianka.png",
        title: "Graphics card",
        html: `Video memory 4G`
      },
      {
        url: "./static/window/c1/xianshipin.png",
        title: "display",
        html: `43’ 3840×2160`
      },
      {
        url: "./static/window/c1/dianrong.png",
        title: "Capacitive touch",
        html: `Support 10 touch`
      },
      {
        url: "./static/window/c1/shexiangtou.png",
        title: "camera",
        html: `1080p HD camera`
      },
      {
        url: "./static/window/c1/laba.png",
        title: "horn",
        html: `2x3W(stereo)`
      }, {
        url: "./static/window/m1/d1-Wi-Fi.png",
        title: "Wi-Fi",
        html: `support IEEE 802.11<br />a/b/g/n 2.4/5GHz`
      },
      {
        url: "./static/window/m1/d1-yitai.png",
        title: "Ethernet",
        html: `1x 10/100/1000M<br />self-adaption`
      },
      {
        url: "./static/window/m1/d1-usb.png",
        title: "USB3.0",
        html: `4×USB3.0 Interface`
      },
      {
        url: "./static/window/m1/d1-HDMI.png",
        title: "HDMI",
        html: `1×HDMI Interface（2.0）`
      },
      {
        url: "./static/window/m1/c1-jiekou.png",
        title: "COM Interface",
        html: `1×COM Interface`
      },
      {
        url: "./static/window/m1/d1-yinpin.png",
        title: "audio frequency",
        html: `1×audio frequency Interface`
      },
      {
        url: "./static/window/m1/d1-dianyuan.png",
        title: "Power Supply",
        html: `1 x DC Power interface`
      }, {
        url: "./static/window/m1/d1-chicun.png",
        title: "size",
        html: `equipment394*171*1017mm<br />packing394*171*1017mm`
      },
      {
        url: "./static/window/m1/d1-zhongliang.png",
        title: "weight",
        html: `16.5Kg`
      },
      {
        url: "./static/window/m1/d1-shuchu.png",
        title: "Power input",
        html: `AC100~120V<br />AC200~240V`
      },
      {
        url: "./static/window/m1/d1-huanjing.png",
        title: "work environment",
        html: `working temperature：0 ~ 40℃<br />Storage temperature：-20℃ ~ 55℃`
      }
    ],
    listData3_mobile: [
      {
        url: "./static/window/mobileM1C1C2D1/xitong.png",
        title: "system",
        html: `Window 10`
      },
      {
        url: "./static/window/mobileM1C1C2D1/cpu.png",
        title: "CPU",
        html: `6-core 3.0G`
      },
      {
        url: "./static/window/mobileM1C1C2D1/chucun.png",
        title: "storage",
        html: `PCIE SSD<br />Solid state disk<br />120g`
      },
      {
        url: "./static/window/mobileM1C1C2D1/neicun.png",
        title: "Memory",
        html: `DDR4 2133<br />8G`
      },
      {
        url: "./static/window/mobileM1C1C2D1/xianka.png",
        title: "Graphics card",
        html: `Display memory<br />4G`
      },
      {
        url: "./static/window/mobileM1C1C2D1/xianshi.png",
        title: "display",
        html: ` 43’ <br />3840×2160`
      },
      {
        url: "./static/window/mobileM1C1C2D1/chumo.png",
        title: "Capacitive touch",
        html: `Support 10<br />touch`
      },
      {
        url: "./static/window/mobileM1C1C2D1/shexiang.png",
        title: "camera",
        html: `1080P high<br />definition camera`
      },
      {
        url: "./static/window/mobileM1C1C2D1/laba.png",
        title: "horn",
        html: `2x3W(stereo)`
      }, {
        url: "./static/window/mobileM1C1C2D1/wifi.png",
        title: "Wi-Fi",
        html: `support IEEE<br />802.11a/b/g<br />/n 2.4/5GHz`
      },
      {
        url: "./static/window/mobileM1C1C2D1/yitai.png",
        title: "Ethernet",
        html: `1个 10/100/<br />1000Mself-adaption`
      },
      {
        url: "./static/window/mobileM1C1C2D1/usb2.png",
        title: "USB3.0",
        html: `4×USB3.0Interface`
      },
      {
        url: "./static/window/mobileM1C1C2D1/hdmi.png",
        title: "HDMI",
        html: `1×HDMI<br />Interface（2.0）`
      },
      {
        url: "./static/window/mobileM1C1C2D1/jiekou.png",
        title: "COM Interface",
        html: `1×COM<br />Interface`
      },
      {
        url: "./static/window/mobileM1C1C2D1/yinpin.png",
        title: "audio frequency",
        html: `1×audio frequency<br />Interface`
      },
      {
        url: "./static/window/mobileM1C1C2D1/dianyuan.png",
        title: "Power Supply",
        html: `1 x DC Power<br />Supply Interface`
      }, {
        url: "./static/window/mobileM1C1C2D1/chicun.png",
        title: "size",
        html: `equipment394*171<br />*1017mm packing<br />394*171*1017<br />mm`
      },
      {
        url: "./static/window/mobileM1C1C2D1/zhongliang.png",
        title: "weight",
        html: `16.5Kg`
      },
      {
        url: "./static/window/mobileM1C1C2D1/shuru.png",
        title: "Power input",
        html: `AC100~120V<br />AC200~240V`
      },
      {
        url: "./static/window/mobileM1C1C2D1/huanjing.png",
        title: "work environment",
        html: `working temperature<br />0~40℃Storage<br />temperature<br />-20℃ ~ 55℃`
      }
    ],
  },
  c2: {
    t1: 'Standard Edition',
    t2: "Full HD camera<br />43 '4K full vision HD touch display integrated large screen<br />Domestic well-known directional noise reduction microphone<br />It adopts internationally renowned capacitive touch screen with fast response and high precision<br />Chanve OS provides services such as application market management, screen hegemony, remote control, gray scale upgrading, etc",
    t3: 'Application scenario',
    t4: 'Shopping centers, office buildings, hospitals, schools, airports, high-speed railway stations, etc',
    t4_mobile: 'Inventor of 2D / 3D indoor map and navigation guidance system<br />（National invention patent No：201310272792.3）',
    t5: 'on-line',
    t6: 'Open the web page and you can draw',
    listData2: [
      {
        url: "./static/window/c1/chumo.png",
        title: "Capacitive touch"
      },
      {
        url: "./static/window/c1/4k.png",
        title: "4K display"
      },
      {
        url: "./static/window/c1/tongji.png",
        title: "Usage statistics"
      },
      {
        url: "./static/window/c1/yuyin.png",
        title: "Voice service"
      }
    ],
    listData2_B: [
      {
        url: "./static/window/c2/shebao.png",
        title: "Insert social security card"
      },
      {
        url: "./static/window/c2/erweima.png",
        title: "QR code recognition"
      },
      {
        url: "./static/window/c2/zhengjian.png",
        title: "Certificate identification"
      }
    ],
    mobile2_B: [
      {
        url: "./static/window/c2/shebaoicon.png",
        title: "Insert social security card"
      },
      {
        url: "./static/window/c2/erweimaicon.png",
        title: "QR code recognition"
      },
      {
        url: "./static/window/c2/zhengjianicon.png",
        title: "Certificate identification"
      }
    ],
    t7: 'technical specifications',
    listData3: [
      {
        url: "./static/window/m1/d1-xitong.png",
        title: "system",
        html: `Window 10`
      },
      {
        url: "./static/window/m1/d1-cpu.png",
        title: "CPU",
        html: `6-core 3G`
      },
      {
        url: "./static/window/m1/d1-chucun.png",
        title: "storage",
        html: `PCIE<br />SSDSolid state disk120g`
      },
      {
        url: "./static/window/m1/d1-neicun.png",
        title: "Memory",
        html: `DDR4 2133 8G`
      },
      {
        url: "./static/window/m1/c1-xianka.png",
        title: "Graphics card",
        html: `Display memory4G`
      },
      {
        url: "./static/window/c1/xianshipin.png",
        title: "display",
        html: `43’ 3840×2160`
      },
      {
        url: "./static/window/c1/dianrong.png",
        title: "Capacitive touch",
        html: `Support 10 touch`
      },
      {
        url: "./static/window/c1/shexiangtou.png",
        title: "camera",
        html: `1080PHD camera`
      },
      {
        url: "./static/window/c1/laba.png",
        title: "horn",
        html: `2x3W(stereo)`
      }, {
        url: "./static/window/m1/d1-Wi-Fi.png",
        title: "Wi-Fi",
        html: `support IEEE 802.11<br />a/b/g/n 2.4/5GHz`
      },
      {
        url: "./static/window/m1/d1-yitai.png",
        title: "Ethernet",
        html: `1个 10/100/1000M<br />self-adaption`
      },
      {
        url: "./static/window/m1/d1-usb.png",
        title: "USB3.0",
        html: `4×USB Interface`
      },
      {
        url: "./static/window/m1/d1-HDMI.png",
        title: "HDMI",
        html: `1×HDMI Interface（2.0）`
      },
      {
        url: "./static/window/m1/c1-jiekou.png",
        title: "COM Interface",
        html: `1×COM Interface`
      },
      {
        url: "./static/window/m1/d1-yinpin.png",
        title: "audio frequency",
        html: `1×audio frequency Interface`
      },
      {
        url: "./static/window/m1/d1-dianyuan.png",
        title: "Power Supply",
        html: `1 x DC Power Supply Interface`
      }, {
        url: "./static/window/m1/d1-chicun.png",
        title: "size",
        html: `equipment394*171*1017mm<br />packing394*171*1017mm`
      },
      {
        url: "./static/window/m1/d1-zhongliang.png",
        title: "weight",
        html: `16.5Kg`
      },
      {
        url: "./static/window/m1/d1-shuchu.png",
        title: "Power input",
        html: `AC100~120V<br />AC200~240V`
      },
      {
        url: "./static/window/m1/d1-huanjing.png",
        title: "work environment",
        html: `working temperature：0 ~ 40℃<br />Storage temperature：-20℃ ~ 55℃`
      },
      {
        url: "./static/window/m1/c2-shebaoka.png",
        title: "Social security card ",
        html: `Insert social security card identification`
      },
      {
        url: "./static/window/m1/c2-erweima.png",
        title: "QR code",
        html: `QR code recognition`
      },
      {
        url: "./static/window/m1/c2-zhengjian.png",
        title: "certificates",
        html: `Certificate identification`
      }
    ],
    listData3_mobile: [
      {
        url: "./static/window/mobileM1C1C2D1/xitong.png",
        title: "system",
        html: `Window 10`
      },
      {
        url: "./static/window/mobileM1C1C2D1/cpu.png",
        title: "CPU",
        html: `6-core 3.0G`
      },
      {
        url: "./static/window/mobileM1C1C2D1/chucun.png",
        title: "storage",
        html: `PCIE SSD<br />Solid state disk<br />120g`
      },
      {
        url: "./static/window/mobileM1C1C2D1/neicun.png",
        title: "Memory",
        html: `DDR4 2133<br />8G`
      },
      {
        url: "./static/window/mobileM1C1C2D1/xianka.png",
        title: "Graphics card",
        html: `Display memory<br />4G`
      },
      {
        url: "./static/window/mobileM1C1C2D1/xianshi.png",
        title: "display",
        html: ` 43’ <br />3840×2160`
      },
      {
        url: "./static/window/mobileM1C1C2D1/chumo.png",
        title: "Capacitive touch",
        html: `Support 10<br />touch`
      },
      {
        url: "./static/window/mobileM1C1C2D1/shexiang.png",
        title: "camera",
        html: `1080P high<br />definition camera`
      },
      {
        url: "./static/window/mobileM1C1C2D1/laba.png",
        title: "horn",
        html: `2x3W(stereo)`
      }, {
        url: "./static/window/mobileM1C1C2D1/wifi.png",
        title: "Wi-Fi",
        html: `support IEEE<br />802.11a/b/g<br />/n 2.4/5GHz`
      },
      {
        url: "./static/window/mobileM1C1C2D1/yitai.png",
        title: "Ethernet",
        html: `1个 10/100/<br />1000Mself-adaption`
      },
      {
        url: "./static/window/mobileM1C1C2D1/usb2.png",
        title: "USB3.0",
        html: `4×USB3.0`
      },
      {
        url: "./static/window/mobileM1C1C2D1/hdmi.png",
        title: "HDMI",
        html: `1×HDMI<br />Interface（2.0）`
      },
      {
        url: "./static/window/mobileM1C1C2D1/jiekou.png",
        title: "COM Interface",
        html: `1×COM<br />Interface`
      },
      {
        url: "./static/window/mobileM1C1C2D1/yinpin.png",
        title: "audio frequency",
        html: `1×audio frequency<br />Interface`
      },
      {
        url: "./static/window/mobileM1C1C2D1/dianyuan.png",
        title: "Power Supply",
        html: `1 x DC Power<br />Supply Interface`
      }, {
        url: "./static/window/mobileM1C1C2D1/chicun.png",
        title: "size",
        html: `equipment394*171<br />*1017mm packing<br />394*171*1017<br />mm`
      },
      {
        url: "./static/window/mobileM1C1C2D1/zhongliang.png",
        title: "weight",
        html: `16.5Kg`
      },
      {
        url: "./static/window/mobileM1C1C2D1/shuru.png",
        title: "Power input",
        html: `AC100~120V<br />AC200~240V`
      },
      {
        url: "./static/window/mobileM1C1C2D1/huanjing.png",
        title: "work environment",
        html: `working temperature<br />0~40℃Storage<br />temperature<br />-20℃ ~ 55℃`
      },
      {
        url: "./static/window/mobileM1C1C2D1/shebao.png",
        title: "Social security",
        html: `Insert social<br />security card<br />distinguish`
      },
      {
        url: "./static/window/mobileM1C1C2D1/erwei.png",
        title: "QR code",
        html: `QR code<br />distinguish`
      },
      {
        url: "./static/window/mobileM1C1C2D1/zhengjian.png",
        title: "certificates",
        html: `certificates<br />distinguish`
      }
    ],
  },
  d1: {
    t1: 'Desktop version',
    t2: "Full HD camera<br />10.1 'full vision HD touch display integrated large screen<br />Domestic well-known directional noise reduction microphone<br />It adopts internationally renowned capacitive touch screen with fast response and high precision<br />Chanve OS provides services such as application market management, screen hegemony, remote<br />control, gray scale upgrading, etc",
    t2_mobile: "Full HD camera<br />10.1 'full vision HD touch display integrated large screen<br />Domestic well-known directional noise reduction microphone<br />It adopts internationally renowned capacitive touch screen<br />with fast response and highprecision Chanve OS provides<br />services such as application market management,screen<br />hegemony, remote control, gray scale upgrading, etc", t4: '购物中心、写字楼、医院、学校、机场、高铁站等',
    t4_mobile: '2D/3D室内地图及导航指引系统的发明者<br />（国家发明专利号：201310272792.3）',
    t5: '在线',
    t6: '打开网页就能画',
    listData2: [
      {
        url: "./static/window/c1/chumo.png",
        title: "Capacitive touch"
      },
      {
        url: "./static/window/d1/gaoqing.png",
        title: "high definition display"
      },
      {
        url: "./static/window/c1/tongji.png",
        title: "Usage statistics"
      },
      {
        url: "./static/window/c1/yuyin.png",
        title: "Voice service"
      }
    ],
    t7: 'technical specifications',
    listData3: [
      {
        url: "./static/window/m1/d1-xitong.png",
        title: "system",
        html: `Window 10`
      },
      {
        url: "./static/window/m1/d1-cpu.png",
        title: "CPU",
        html: `8-core 2G`
      },
      {
        url: "./static/window/m1/d1-chucun.png",
        title: "storage",
        html: `RAM 2G`
      },
      {
        url: "./static/window/m1/d1-neicun.png",
        title: "Memory",
        html: `16G`
      },
      {
        url: "./static/window/c1/xianshipin.png",
        title: "display",
        html: `10.1’ 1200*1920`
      },
      {
        url: "./static/window/c1/dianrong.png",
        title: "Capacitive touch",
        html: `Support 10 touch`
      },
      {
        url: "./static/window/c1/shexiangtou.png",
        title: "camera",
        html: `200W pixel camera`
      },
      {
        url: "./static/window/c1/laba.png",
        title: "horn",
        html: `2x1W(stereo)`
      }, {
        url: "./static/window/m1/d1-Wi-Fi.png",
        title: "Wi-Fi",
        html: `support IEEE 802.11<br />a/b/g/n 2.4/5GHz`
      },
      {
        url: "./static/window/m1/d1-yitai.png",
        title: "Ethernet",
        html: `1个 10/100/1000M<br />self-adaption`
      },
      {
        url: "./static/window/m1/d1-usb.png",
        title: "USB2.0",
        html: `2×USB2.0Interface`
      },
      {
        url: "./static/window/m1/d1-HDMI.png",
        title: "HDMI",
        html: `1×HDMIInterface（2.0）`
      },
      {
        url: "./static/window/m1/d1-yinpin.png",
        title: "audio frequency",
        html: `1×audio frequency Interface`
      },
      {
        url: "./static/window/m1/d1-dianyuan.png",
        title: "Power Supply",
        html: `1 x DCPower Supply Interface`
      }, {
        url: "./static/window/m1/d1-chicun.png",
        title: "size",
        html: `equipment300*150*180mm<br />packing320*170*200mm`
      },
      {
        url: "./static/window/m1/d1-zhongliang.png",
        title: "weight",
        html: `0.25Kg`
      },
      {
        url: "./static/window/m1/d1-shuchu.png",
        title: "Power input",
        html: `5V/2A`
      },
      {
        url: "./static/window/m1/d1-huanjing.png",
        title: "work environment",
        html: `working temperature：0 ~ 40℃<br />Storage temperature：-20℃ ~ 55℃`
      }
    ],
    listData3_mobile: [
      {
        url: "./static/window/mobileM1C1C2D1/xitong.png",
        title: "system",
        html: `Android 9.0`
      },
      {
        url: "./static/window/mobileM1C1C2D1/cpu.png",
        title: "CPU",
        html: `4-core 1.8 G`
      },
      {
        url: "./static/window/mobileM1C1C2D1/chucun.png",
        title: "storage",
        html: `RAM 2G`
      },
      {
        url: "./static/window/mobileM1C1C2D1/neicun.png",
        title: "Memory",
        html: `16G`
      },
      {
        url: "./static/window/mobileM1C1C2D1/xianshi.png",
        title: "display",
        html: `10.1’<br />1200*1920`
      },
      {
        url: "./static/window/mobileM1C1C2D1/chumo.png",
        title: "Capacitive touch",
        html: `Support 10<br />points feel`
      },
      {
        url: "./static/window/mobileM1C1C2D1/shexiang.png",
        title: "camera",
        html: `200W pixel<br />camera`
      },
      {
        url: "./static/window/mobileM1C1C2D1/laba.png",
        title: "horn",
        html: `2x1W(stereo)`
      }, {
        url: "./static/window/mobileM1C1C2D1/wifi.png",
        title: "Wi-Fi",
        html: `support IEEE<br />802.11a/b/g<br />/n 2.4/5GHz`
      },
      {
        url: "./static/window/mobileM1C1C2D1/yitai.png",
        title: "Ethernet",
        html: `1个 10/100/<br />1000 Mself-adaption`
      },
      {
        url: "./static/window/mobileM1C1C2D1/usb2.png",
        title: "USB2.0",
        html: `2×USB2.0`
      },
      {
        url: "./static/window/mobileM1C1C2D1/hdmi.png",
        title: "HDMI",
        html: `1×HDMI<br />Interface（2.0）`
      },
      {
        url: "./static/window/mobileM1C1C2D1/yinpin.png",
        title: "audio frequency",
        html: `1×audio<br />frequency Interface`
      },
      {
        url: "./static/window/mobileM1C1C2D1/dianyuan.png",
        title: "Power Supply",
        html: `1 x DC Power<br />Supply Interface`
      }, {
        url: "./static/window/mobileM1C1C2D1/chicun.png",
        title: "size",
        html: `equipment300*150<br />*180mm packing<br />320*170*200<br />mm`
      },
      {
        url: "./static/window/mobileM1C1C2D1/zhongliang.png",
        title: "weight",
        html: `0.25Kg`
      },
      {
        url: "./static/window/mobileM1C1C2D1/shuru.png",
        title: "Power input",
        html: `5V/2A`
      },
      {
        url: "./static/window/mobileM1C1C2D1/huanjing.png",
        title: "work environment",
        html: `working temperature<br />0 ~ 40℃<br />Storage temperature<br />-20℃ ~ 55℃`
      }
    ],
  },
  cmappax: {
    t1: "A tool for online mapping",
    t2: "What is cmappax？",
    t3:
      "Cmappax is an online mapping tool.<br>It supports online drawing of exquisite 2D / 3D maps with different styles, open the web page to view and edit, save in real time in the cloud,<br> edit files in real time online, with safe and controllable permissions.",
    t4:
      'Chaunve has invented "display and guidance or navigation method of 2D / 3D map". (National Invention Patent No.: 201310272792.3)',
    t4_mobile:
      'Chaunve has invented "display and guidance or navigation method of 2D / 3D map". (National Invention Patent No.: 201310272792.3)',
    t5: "Online",
    t6: "Open the web page and you can draw",

    t7: " No need to install any software, you can just click ",
    t7_1: " start to draw your map.",

    t8: "Anytime, anywhere to use ",
    t9:
      "No matter where you are, as long as you connected to the internet you can check, draw and edit your map.",

    t10: "Efficient",
    t11: "Fast drawing and one step edit.",

    t12:
      "You can easily draw your map by draging the mouse. Indoor and outdoor map effect is clear and visible.",
    t13: "Quick adjustment in one click",
    t14:
      "With one click of the mouse, you can switch to multiple sets of topics, and click to release and view the map effect.",

    t15: "Secure",
    t16: "Power off protection, data security",
    t17: `The system will save your operation scene automatically, so you don't have to worry about the loss of editing content caused by power failure.`,
    t18: "Small tools, many possibilities",
    t19: "cmappax can perfectly match your mapping needs",
    t20:
      "It can draw exquisite and personalized 2D / 3D maps to meet the needs of different business scenarios",
    t20_mobile:
      "It can draw exquisite and personalized 2D / 3D maps to meet the needs of different business scenarios",
    t21: "即将上线...",
    t22: "Click the left button to control the map",
    t23: "Press and hold the scroll wheel down to continue browsing",
    t24: "Press and hold the right button to rotate the map",
    t25: "Open API",

    t26: "Team access to enhance productivity",
    t27:
      "Through the cmapax map API, maps can be applied to different platforms around the world for display, so that the maps you make are everywhere. Map data will be encrypted storage, making the data more secure.",

    t28: "Meet the need of platform/team access ",
    t29:
      "Support third-party account login, meet the authorization of third-party organization structure, and seamlessly connect with the application platform.",
    t30: "Enjoy consistent experience",
    t31:
      "It provides a full set of editing capabilities, and gradually optimizes and improves them,which can deliver consistent experience to users.",
    t32: "Secure",
    t33: "Power off protection, data security",
    t34:
      "After encrypted storage, the data is encrypted with HTTPS throughout the process to ensure the security of data from access, transmission to storage.",
    t35: "Application scenario solution",
    t36: "Seamless connection",
    t37: `Cmappax is a high-efficiency, flexible multi platform map drawing tool developed by Shenzhen Chaunve Technology Co., Ltd. with its own products and professional 3D map technology.
    Provide indoor map technical support and accurate indoor positioning technology for many platforms as the core function, customize the indoor shopping guide system for clients such as shopping malls, office buildings, hospitals, schools, public parks, and provide customized services.`,
    t38: "Try it now",
    listData1: [
      {
        img: "./static/window/cmappax/icon1.png",
        title: "Multi abilities",
        des:
          "The system has fast split, merge, path connection, Boolean operation, POI setting and many other functions "
      },
      {
        img: "./static/window/cmappax/icon2.png",
        title: "Multi layers",
        des:
          "According to different business needs, different layer information can be called on demand"
      },
      {
        img: "./static/window/cmappax/icon3.png",
        title: "Multiple skins",
        des:
          "The system has a variety of map skins, and it can swift by one button click to meet different design needs"
      },
      {
        img: "./static/window/cmappax/icon4.png",
        title: "Multiple topics",
        des:
          "By one same background, it can create maps with different themes to meet the needs of personalized display"
      },
      {
        img: "./static/window/cmappax/icon5.png",
        title: "Multi permissions",
        des:
          "Set different authority management independently <br>to meet the needs of differentiated management"
      },
      {
        img: "./static/window/cmappax/icon6.png",
        title: "Multi platforms",
        des:
          "Support different platform calls to meet the needs of multiple business scenarios"
      }
    ]
  },
  consult: {
    t1: "Focus on creating value, professional and perfection",
    t2: `We fully understand the importance of first and continuous evaluation and implement it in project management. We strictly implement the evaluation and analysis procedures before and during project design and implementation. We also rely on these professional experience to provide independent consulting services. The consulting team consists of managers with front-line operational experience, senior design directors, and senior IT directors to provide pre-planning solution evaluation, ongoing project evaluation and fine-tuning, as well as evaluation of completed project potential and redevelopment opportunities.Previous experience shows that whether it is an independent shopping center or a large-scale urban complex, a well thought out design can not only have a fundamental impact on the aesthetic success of the project, but also contribute to the economic success of the project. On the basis of fully exploring business opportunities, if it can be supplemented with effective design, it can effectively improve brand reputation, enhance user experience and reduce operating costs.`
  },
  onemap: {
    t1: "New generation of integrated content management platform",
    t2: "New generation business intelligence system of map",
    t3:
      'With the help of online mapping tool cmappax, a business intelligence system is built up for data collection, calculation and processing. All data is stored with unified standard as company asset for the better analysis and review in the future.With fully flexible API, the data is interconnectable to all systems, building up a comprehensive "one map" system with products of Chaunve. It solves the problem of originally scattered data and truly realizes a integrated system.',
    t3_mobile:
      'With the help of online mapping tool cmappax, a business intelligence system is built up for data collection, calculation and processing. All data is stored with unified standard as company asset for the better analysis and review in the future.With fully flexible API, the data is interconnectable to all systems, building up a comprehensive "one map" system with products of Chaunve. It solves the problem of originally scattered data and truly realizes a integrated system.',
    t4: "system advantages",
    taxtData: [
      {
        title: "Consistent Customer experience",
        url: "./static/window/onemap/a.png",
        html: `The experiences across different platforms are <br>consistent to different customers.`,
        html1: `The experiences across different platforms are consistent to different customers.`
      },
      {
        title: "API",
        url: "./static/window/onemap/b.png",
        html: `The API can be called upon by different platforms to meet different data needs to ensure the consistency of data source.`,
        html1: `The API can be called upon by different platforms to meet different data needs to ensure the consistency of data source.`
      },
      {
        title: "Dynamic display options",
        url: "./static/window/onemap/c.png",
        html: `The map changes in  a dynamic way to display <br> different information.`,
        html1: `The map changes in a dynamic way to display different information.`
      },
      {
        title: "Efficiency",
        url: "./static/window/onemap/d.png",
        html: `Clients can mange the data and contents in display via a smart backend, including space information, routing, POI data, pattern design, effect, theme, etc.`,
        html1: `Clients can mange the data and contents in display via a smart backend, including space information, routing, POI data, pattern design, effect, theme, etc. `
      },
      {
        title: "Centralised management",
        url: "./static/window/onemap/e.png",
        html: `All maps are managed and updated via a centralised system. All map data will be synchronised automatically across displays, mobiles and websites, etc. All updates are made once and synced simultaneously. `,
        html1: `All maps are managed and updated via a centralised system. All map data will be synchronised automatically across displays, mobiles and websites, etc. All updates are made once and synced simultaneously. `
      }
    ]
  },
  ids: {
    t1: "Complicated Way-Finding Info Displayed In Simplicity",
    t2:
      "Interactive Directory System (IDS) is an integrated solution to present complicated way-finding information in a simple way",
    t3: `Chaunve's interactive directory system (IDS) is a breakthrough of the traditional signage system, integrating interactive functions, intelligence and experiential elements into one system. The integrated IDS provides services of way-finding, shopping directory, advertisement, entertainment, information release, contact, car-finding and parking payment, VIP services, etc. The system meets the ever changing needs of customers to fulfill their enquiries on information in need, greatly alleviating the pressure of concierge. The system, with the state-of-art audiovisual and touch experiences, bridges property owners and customers in a creative, dynamic way for efficient communication.`,

    t4:
      "Screens are the most direct and important interaction portal with customers.",
    t5: `Chaunve's hardware meets physical environment, ensuring all focuses are on the interface. With the integration of software and hardware, a solution that is both visually appealing and also practical will be provided to clients. The system also allows users to interact with the screen with their mobiles, getting experiences beyond expectation. `,

    t6: "Chaunve, setting a new standard for customer experience",
    t7:
      "With over 10 years of development, the interactive directory system has all the functions to be tailored for your project to be a perfect fit. ",

    t8: "one map、one cms，Create a unified background management system",

    t9: "With the help of online mapping tool cmappax,",
    t9_1:
      'a business intelligence system is built up for data collection, calculation and processing. All data is stored with unified standard as company asset for the better analysis and review in the future. With fully flexible API, the data is interconnectable to all systems, building up a comprehensive "one map" system with products of Chaunve. It solves the problem of originally scattered data and truly realizes a integrated system.',

    t9_mobile: "With the help of online mapping tool cmappax,",
    t9_mobile_1: `a business intelligence system is built up for data collection, calculation and processing. All data is stored with unified standard as company asset for the better analysis and review in the future. With fully flexible API, the data is interconnectable to all systems, building up a comprehensive "one map" system with products of Chaunve. It solves the problem of originally scattered data and truly realizes a integrated system.`,

    t10: "Chaunve has installed over 16,000 screens worldwide",
    t11: `Our clients are from different industries including Wharf Group, Hang Lung Group, Sun Hung Kai Group, China Resource Group, Vanke Group, providing advanced user experience to clients' projects. We hold a user-entered attitude to provide solution to various industries and scenarios.`,
    t11_mobile: `Our clients are from different industries including Wharf Group, Hang Lung Group, Sun Hung Kai Group, China Resource Group, Vanke Group, providing advanced user experience to clients' projects. We hold a user-entered attitude to provide solution to various industries and scenarios.`,
    listData2: [
      {
        title: "UHD 4K display technology"
      },
      {
        title: "Multi touch technology"
      },
      {
        title: "Face recognition technology"
      },
      {
        title: "Speech recognition technology"
      }
    ],
    listData2_R: [
      {
        title: "Camera"
      },
      {
        title: "Microphone"
      },
      {
        title: "RFID"
      },
      {
        title: "QR Code"
      }
    ],
    listData3: [
      {
        url: "static/window/ids/device1.png",
        title: "Horizontal screen floor type"
      },
      {
        url: "./static/window/interactive/device2.png",
        title: "Vertical screen floor type"
      },
      {
        url: "./static/window/interactive/device3.png",
        title: "Vertical screen wall hanging / Embedded"
      },
      {
        url: "./static/window/interactive/device4.png",
        title: "Horizontal screen wall hanging / Embedded"
      },
      {
        url: "./static/window/interactive/device5.png",
        title: "Mobile wechat / Applet / H5 / APP"
      }
    ]
  },
  sds: {
    t1: "quick and effective instructions",
    t2:
      "Static Directory system is a perfect supplement to your digital platform, enable you to push your contents to all places immediately. They are the best option for message delivery and promotions. They can also be a part of an advertisement series or tailored content release based on locations.",
    t2_mobile:
      "Static Directory system is a perfect supplement to your digital platform, enable you to push your contents to all places immediately. They are the best option for message delivery and promotions. They can also be a part of an advertisement series or tailored content release based on locations.",
    t3:
      "We went through blackboards, artworks, printouts, lightbox… and other traditional way of advertisement channels. Visuals are simple and takes great effort to be updated.",
    t3_mobile:
      "We went through blackboards, artworks, printouts, lightbox… and other traditional way of advertisement channels. Visuals are simple and takes great effort to be updated.",
    t4:
      "Now we are entering digital era, with the development of technology. The displays are equipped with interactive functions, sensors and the contents are more diverse.",
    t5:
      "It solves the problem of manual update on-site which takes manpower time and cost and lowered the value of displays. ",
    t6: "Default advertisement",
    t7: "Infrared induction",
    t8: "Traditional light box",
    t9: "System advantages",
    listData2: [
      {
        url: "./static/window/sds/list2_icon1.svg",
        url1: "static/mobile/sds/3.png",
        title: "The picture is single"
      },
      {
        url: "./static/window/sds/list2_icon2.svg",
        url1: "static/mobile/sds/4.png",
        title: "High cost"
      },
      {
        url: "./static/window/sds/list2_icon3.svg",
        url1: "static/mobile/sds/5.png",
        title: "Not easy to update"
      }
    ],
    listData3: [
      {
        url: "./static/window/sds/list3_icon1.svg",
        url1: "static/mobile/sds/6.png",
        title: "Rich pictures"
      },
      {
        url: "./static/window/sds/list3_icon2.svg",
        url1: "static/mobile/sds/7.png",
        title: "Interactivity"
      },
      {
        url: "./static/window/sds/list3_icon3.svg",
        url1: "static/mobile/sds/8.png",
        title: "sensor"
      }
    ],
    listData4: [
      {
        url: "./static/window/sds/a.png",
        title: "Dynamic display"
      },
      {
        url: "./static/window/sds/b.png",
        title: "Centralised management"
      },
      {
        url: "./static/window/sds/c.png",
        title: "Media display"
      },
      {
        url: "./static/window/sds/d.png",
        title: "Consistent hardware design"
      }
    ]
  },
  mids: {
    t1: "Your advertisement everywhere, no more printouts",
    t2: "Media release on a click",
    t3:
      " Chaunve has developed a complicated cloud-based media platform to you to enjoy the convenience of media content management.<br /> The platform supports different media format and can be played to your playlist set to time and date.<br /> Screens can be grouped to your like and display images, animation or audiovisual contents separately by group. ",
    t4: "Frames",
    t5:
      "All kinds of frames can be tailor made to your requirement. Wall-mount, desk-embedded or installed into signage. They can help you release your information, promotion and advertisements in a flexible way. ",
    t5_mobile:
      "All kinds of frames can be tailor made to your requirement. Wall-mount, desk-embedded or installed into signage. They can help you release your information, promotion and advertisements in a flexible way. ",
    t6: "Media content management",
    t7:
      "With the media content management, users can directly manage the contents in the system and arrange the layout online. Playlist, content and censoring can all be managed online. ",
    t9: "Face recognition",
    t10: `System supports face recognition with an AI camera which can help analyse users' age, gender and estimate their preference to push personalised advertisements to maximise the exposure.`,
    t11:
      '<img style="width:.2rem;margin-right:.1rem;" src="static/window/mids/ai/i0.png" alt="">AI camera',
    t12: "Data analysis",
    t13: "Face recognition",
    t14: "Enhance members<br>sense of belonging",
    t15: "Precise delivery",
    listData2: [
      {
        url: "./static/window/mids/ai/i0.png",
        title: "AI camera",
        delay: 2
      },
      {
        url: "./static/window/mids/ai/i1.png",
        title: "Data analysis",
        delay: 5
      },
      {
        url: "./static/window/mids/ai/i2.png",
        title: "Face recognition",
        delay: 5
      },
      {
        url: "./static/window/mids/ai/i3.png",
        title: "Enhance members' sense of belonging",
        delay: 5
      },
      {
        url: "./static/window/mids/ai/i4.png",
        title: "Precise delivery",
        delay: 5
      }
    ],
    listData3: [
      {
        url: "./static/window/mids/manage/1.png",
        title: "Layout settings"
      },
      {
        url: "./static/window/mids/manage/2.png",
        title: "Program management"
      },
      {
        url: "./static/window/mids/manage/3.png",
        title: "Material management"
      },
      {
        url: "./static/window/mids/manage/4.png",
        title: "device management"
      }
    ]
  },
  csps: {
    t1: "Find your car and pay in a more convenient way",
    t2: "There is no need to wait for car search and payment",
    t3: `Chaunve's car-finding system is an integrated system for parking fee payment and car-finding.The system automatically calculates parking fee based on its time of entry. And drivers can pay via Alipay, WePay, credit card or face identification.`,
    t4: "Car-finding",
    t5:
      "Users can find their car using car plate, lot number or face identification. And the location will be displayed on 3D map which can be synchronised to mobile via QR code for mobile navigation. Car-finding has never been easier.",
    t6: "Face recognition for car-finding and payment",
    t7:
      "Users can stand in front of the car-finding and payment system. And the system can help you find your car and settle your bill by identifying your face. ",
    listData1: [
      {
        url: "./static/window/csps/list1_icon1.png",
        url1: "./static/mobile/csps/icon1.png",
        title: "Brush your face <br> to find a car"
      },
      {
        url: "./static/window/csps/list1_icon2.png",
        url1: "./static/mobile/csps/icon2.png",
        title: "License plate <br> search"
      },
      {
        url: "./static/window/csps/list1_icon3.png",
        url1: "./static/mobile/csps/icon3.png",
        title: "Parking space <br> search"
      },
      {
        url: "./static/window/csps/list1_icon4.png",
        url1: "./static/mobile/csps/icon4.png",
        title: "Parking <br> fee"
      }
    ]
  },
  indoor: {
    t2: "Help you find your destination quickly.",
    t3:
      "Based on the self-developed map engine, the system can combine WiFi, Bluetooth, UWB and other positioning methods to help users quickly reach their destinations. Provide positioning accuracy requirements for different business scenarios, and provide indoor positioning technical solutions for different industries.",
    t4: "We establish a new benchmark for customer experience",
    t5: `Our Indoor Navigation System is applicable to all large indoor places, and the navigation lines are presented in real time to help users quickly reach their destinations. The system can run on APP, WeChat official account, applet and so on. It has many functions and has been developed and tested in the market for more than 10 years. Let's recommend the functions that are beneficial to your project and bring better experience to your customers!`,
    t6:
      "Create consistent experience, provide customers with the leading positioning technology",
    t7:
      "After years of research, we have developed high-precision positioning technology and provided the best positioning service products in the industry, which can be connected with the third-party system to achieve data interconnection without affecting the operation of the other system.",
    listData3_0: [
      {
        url: "./static/window/indoor/list3_icon1.png",
        title: "Low data consumption",
        des:
          "Combined with WIFI, Bluetooth, UWB, and other<br> positioning methods, the system consumes low traffic in communications. "
      },
      {
        url: "./static/window/indoor/list3_icon2.png",
        title: "High success rate",
        des:
          "Combined with WIFI, Bluetooth, UWB and <br> other positioning methods, the success rate of positioning is up to 99.6%. "
      },
      {
        url: "./static/window/indoor/list3_icon3.png",
        title: "Navigation route guidance",
        des:
          "Combined with WIFI, Bluetooth, UWB and <br> other positioning methods, the overall accuracy reaches 2-5 meter."
      }
    ],
    listData3_1: [
      {
        url: "./static/window/indoor/list3_icon4.png",
        title: "Millisecond response",
        des: "IP positioning speed is less than 0.2s."
      },
      {
        url: "./static/window/indoor/list3_icon5.png",
        title: "High coverage",
        des: "Base station, Wi-Fi coverage up to 99%."
      },
      {
        url: "./static/window/indoor/list3_icon6.png",
        title: "Low power consumption",
        des: "Low CPU and memory usage."
      }
    ],
    listData1_0: [
      {
        url: "./static/window/indoor/list1_image1.png",
        title: "Shopping Mall"
      },
      {
        url: "./static/window/indoor/list1_image2.png",
        title: "Office building"
      },
      {
        url: "./static/window/indoor/list1_image3.png",
        title: "hospital"
      },
      {
        url: "./static/window/indoor/list1_image4.png",
        title: "school"
      },
      {
        url: "./static/window/indoor/list1_image5.png",
        title: "airport"
      },
      {
        url: "./static/window/indoor/list1_image6.png",
        title: "traffic"
      }
    ]
  },
  ar: {
    t1: "New generation navigation system",
    t2:
      "By modelling on the actual physical world with AI visualisation abilities, AR navigation system can help customers to quickly navigate to its destination with advanced AI technology. The system also serves as a promotional platform for users. The implementation requires no on-site construction works and the navigation can be as accurate as 1m.",
    t2_mobile:
      "By modelling on the actual physical world with AI visualisation abilities, AR navigation system can help customers to quickly navigate to its destination with advanced AI technology. The system also serves as a promotional platform for users. The implementation requires no on-site construction works and the navigation can be as accurate as 1m.",
    t3: "Product architecture",
    t4: "AR Marketing",
    t5: `By analysing the whereabouts and user information, the system recommends a personalised promotional offer to user. Shop information display: average spending, rating, opening hours, etc Shop coupon recommendation: shop's promotional offers are displayed in the AR system for users to redeem directly Shop advertisement display: advertisements can be displayed in the AR system to drive traffic to shops.`,
    listData1: [
      {
        url: "./static/window/ar/list1_icon1.png",
        title: "No hardware required"
      },
      {
        url: "./static/window/ar/list1_icon2.png",
        title: "No construction is required"
      },
      {
        url: "./static/window/ar/list1_icon3.png",
        title: "High precision"
      }
    ]
  },
  easylease: {
    t1: "Your online leasing consultant",
    t2: "Multi-project",
    t3: `By displaying the multiple projects under one group to present a data analysis report in multi dimension. Leasing data can be displayed in multi dimension and leasing progress can be shared simultaneously to increase clients' service quality, increase operators' management ability. `,
    t3_mobile: `By displaying the multiple projects under one group to present a data analysis report in multi dimension. Leasing data can be displayed in multi dimension and leasing progress can be shared simultaneously to increase clients' service quality, increase operators' management ability. `,
    t4: "Single Project",
    t5: `Based on big data, smart analysis is carried out for a single mall to track customers' shopping behaviours to rapidly build up a accurate marketing system and implement various marketing strategies to easily increase customer loyalty and conversion rate.`,
    t5_mobile: `Based on big data, smart analysis is carried out for a single mall to track customers' shopping behaviours to rapidly build up a accurate marketing system and implement various marketing strategies to easily increase customer loyalty and conversion rate.`,
    t6: "Exclusive customer service",
    t7:
      "Leasing representatives can leverage on the platform to communicate with clients and clients can contact back at the same time for leasing enquiries, solving the problem of communication gaps and bringing revolution to the traditional leasing model. ",
    t7_mobile:
      " Leasing representatives can leverage on the platform to communicate with clients and clients can contact back at the same time for leasing enquiries, solving the problem of communication gaps and bringing revolution to the traditional leasing model. ",
    t8: "Visualised leasing",
    t9:
      "Unparalleled leasing experience Multi-trademix display, filter on click",
    t10: "Convenient leasing system",
    t11:
      "Still using floor plans? Taking your clients to the actual site? How to present your project in a better way? Easylease, leasing has never been easier",
    listData2: [
      {
        url: "./static/window/easylease/list2_image1.png",
        title: "Areas for lease",
        des:
          "User can filter out the available leasable area and display on map",
        des1:
          "User can filter out the available leasable area and display on map"
      },
      {
        url: "./static/window/easylease/list2_image2.png",
        title: "Size",
        des: "Each area size is displayed for you to choose",
        des1: "Each area size is displayed for you to choose"
      },
      {
        url: "./static/window/easylease/list2_image3.png",
        title: "Location",
        des: "Location has never been clearer, pick your favourite location",
        des1: "Location has never been clearer, pick your favourite location"
      }
    ],
    listData3_1: [
      {
        url: "./static/window/easylease/list3_icon1.png",
        title: "Project informatio",
        des: "All you want to know about the project"
      },
      {
        url: "./static/window/easylease/list3_icon2.png",
        title: "Surrounding environments",
        des: "Nearby transportations, environments"
      },
      {
        url: "./static/window/easylease/list3_icon3.png",
        title: "Project environment",
        des: "Can view the real time information of the project "
      },
      {
        url: "./static/window/easylease/list3_icon4.png",
        title: "Online communication",
        des:
          "Real-time communication platform <br> with your leasing representative"
      },
      {
        url: "./static/window/easylease/list3_icon5.png",
        title: "Quick share",
        des: "Share the relevant information on a click"
      },
      {
        url: "./static/window/easylease/list3_icon6.png",
        title: "Online reservation",
        des: "Reserve your favourite spot on a click"
      },
      {
        url: "./static/window/easylease/list3_icon7.png",
        title: "Centralised management",
        des:
          "Leasing information can be updated anytime:<br> area size, status, etc. "
      },
      {
        url: "./static/window/easylease/list3_icon8.png",
        title: "Analysis",
        des: "User data can be analysed"
      }
    ]
  },
  easy2walk: {
    t1: "Finding your ways never being so simple",
    t2:
      "In a strange city where language and environments are unfamiliar. Easy2walk applet is the easiest way to find shops and restaurants in shopping malls also navigation to different destinations. Navigation and shopping information are right on your fingertip. ",
    t3: "Finding your ways never being so simple",
    t4: `In a strange city where language and environments are unfamiliar. Easy2walk applet is the easiest way to find shops and restaurants in shopping malls also navigation to different destinations. Navigation and shopping information are right on your fingertip. `,
    t4_mobile: `In a strange city where language and environments are unfamiliar. Easy2walk applet is the easiest way to find shops and restaurants in shopping malls also navigation to different destinations. Navigation and shopping information are right on your fingertip. `,
    t5: "Easy to find the way from one mall to another",
    t6: `Easy2walk allows you to easily travel between different shopping mall and attractions. Without using different software, you can easily find the nearest shopping mall location, which can be used for store and store navigation at the same time. `,
    t6_mobile:
      "Easy2walk allows you to easily travel between different shopping mall and attractions. Without using different software, you can easily find the nearest shopping mall location, which can be used for store and store navigation at the same time.",
    t7: "Simple and direct shop-finding",
    t8: `Easy2walk contains an analog navigation system, which allows you to quickly find out the stores you want to go to by simply setting the starting and ending points.`,
    t8_mobile: `Easy2walk contains an analog navigation system, which allows you to quickly find out the stores you want to go to by simply setting the starting and ending points.`,
    t9: "Promotion methods",
    listData1: [
      {
        url: "./static/window/easytowalk/list1_icon1.png",
        title: "Overseas promotion",
        des:
          "When visitor comes to a new place, way-finding has always been a problem due to different languages and environments. Restaurant quality, shopping experience and way-finding are the main concerns of visitors.",
        des1:
          "When visitor comes to a new place, way-finding has always been a problem due to different languages and environments. Restaurant quality, shopping experience and way-finding are the main concerns of visitors."
      },
      {
        url: "./static/window/easytowalk/list1_icon2.png",
        title: "City promotion",
        des:
          "For the government to promote local tourism and strengthen the competitiveness of the city.",
        des1:
          "For the government to promote local tourism and strengthen the competitiveness of the city."
      },
      {
        url: "./static/window/easytowalk/list1_icon3.png",
        title: "Market promotion",
        des:
          "Instead of waste time in queue for enquiries, customers can get all the navigation and direction services online. ",
        des1:
          "Instead of waste time in queue for enquiries, customers can get all the navigation and direction services online. "
      }
    ]
  },
  shopping: {
    t1: "Shopping Center Business Intelligence (BI) Solutions",
    t2: "Shopping center strives to provide excellent shopping experience",
    t3:
      "Shopping centersstrive to deliver excellent customer experience in which field Chaunve plays an important and helpful role.",
    t3_mobile:
      "Shopping centersstrive to deliver excellent customer experience in which field Chaunve plays an important and helpful role.",
    t4: `ChaunveInteractive Dictionary System(IDS) was developed specifically for shopping centers in 2008. Since then, it has been installed in more than 500 public places around the world. It has evolved to the present day, where Chaunve is still in the leading position in interactive dictionary system solutions.In the context of the digital age, customers pay much attention to time and efficiency. They want to get the right information quickly and directly. Interactive Dictionary System is the answer to the needs.With just a few touches, the customer can get the desired direction information.Shopping centers pay much attention to design, and the Interactive Dictionary System is the perfect solution. With sleek hardware designs and clear digital displays, Chaunve's products can help to transform any space into a modern and advanced environment.`,
    t4_mobile: `Chaunve Interactive Dictionary System(IDS) was developed specifically for shopping centers in 2008. Since then, it has been installed in more than 500 public places around the world. It has evolved to the present day, where Chaunve is still in the leading position in interactive dictionary system solutions.In the context of the digital age, customers pay much attention to time and efficiency. They want to get the right information quickly and directly. Interactive Dictionary System is the answer to the needs.With just a few touches, the customer can get the desired direction information.Shopping centers pay much attention to design, and the Interactive Dictionary System is the perfect solution. With sleek hardware designs and clear digital displays, Chaunve's products can help to transform any space into a modern and advanced environment.`,
    t5:
      'Chaunve has invented 2D/3D indoor map and patended technology of "display and guidance or navigation method of 2D/3D map". It supports updates, splits and merges the berths to create a "one map" service for enterprises, which can be used for different business systems, combined with mature navigation technologies such as bluetooth, WIFI, AR etc. It can realize indoor positioning and navigation services, which are widely used in artificial intelligence, big data, cloud computing and Internet of things, and so on.',
    t6: "Intelligent Commerce",
    t7:
      "Which brands do customers like? How many times have the customer visited? How to improveuser experience? How to optimize service capability?Through advanced technologies such as indoor maps, indoor positioning and big data analysis, Chaunve helps merchants to bring unprecedented shopping experience to consumers, obtain richer, more valuable and multi-dimensional user portrait reports, realize refined and visual operation, reduce management costs and empower businesses.",
    t8: "Shopping center solutions",
    t9:
      " In addition to the Interactive Dictionary System, we have developed a number of other solutions for shopping centers, including:",
    t10: "We provide solutions for your industry. Contact us now",
    t10_mobile: "We provide solutions for your industry. Contact us now",
    t11: "Apply now"
  },
  hospital: {
    t1: "Hospital Solutions",
    t2: "Hospital is to provide excellent customer experience",
    t3: `Hospital is to deliver a great customer experience, and that's what Chaunve can help with.`,
    t3_mobile: `Hospital is to deliver a great customer experience, and that's what Chaunve can help with.`,
    t4: `ChaunveInteractive Dictionary System(IDS) was developed in 2008. Since then, it has been installed in more than 500 public places around the world. It has evolved to the present day, where Chaunve is still in the leading position in interactive dictionary system solutions.In the context of the digital age, customers pay much attention to time and efficiency. They want to get the right information quickly and directly. Interactive Dictionary System is the answer to the needs.With just a few touches, the customer can get the desired direction information.Hospitalspay much attention to design, and the Interactive Dictionary System is the perfect solution. With sleek hardware designs and clear digital displays, Chaunve's products can help to transform any space into a modern and advanced environment.`,
    t4_mobile: `Chaunve Interactive Dictionary System(IDS) was developed in 2008. Since then, it has been installed in more than 500 public places around the world. It has evolved to the present day, where Chaunve is still in the leading position in interactive dictionary system solutions.In the context of the digital age, customers pay much attention to time and efficiency. They want to get the right information quickly and directly. Interactive Dictionary System is the answer to the needs.With just a few touches, the customer can get the desired direction information.Hospitalspay much attention to design, and the Interactive Dictionary System is the perfect solution. With sleek hardware designs and clear digital displays, Chaunve's products can help to transform any space into a modern and advanced environment.`,
    // t5:'创互创造性发明了2D/3D室内地图，拥有”2D/3D地图的显示及指引或导航方法” 的国家发明专利技术，通过登陆后进行铺位的更新 、拆分和合并，打造企业“一张图”服务，可给不同的业务系统调用，结合成熟的导航技术，如蓝牙, WIFI,AR等可实现室内定位导航服务，产品广泛应用在人工智能、大数据、云计算机及物联网等方面。',
    t6: "Intelligent hospital",
    t7: `The hospital building is complex in structure and crowded with high daily traffic. Medical staff is always disturbed by way-enquiring, reducing their work efficiency. No matter how much human and financial resources are spent on the guiding service, the guiding platform of the hospital is always full of people, and the patients hang up their numbers and don’t know where to go next.The Interactive Dictionary System, combined with WeChat public account and applets, seamlessly connects with the hospital system, providing direction services for patients' medical treatment process, which is more efficient and greatly reduces the pressure of medical staff in hospitals.`,
    t8: "Hospital Solutions",
    t9:
      "In addition to the Interactive Dictionary System, we have developed a number of other solutions for hospitals, including:"
    // t10:'我们为您的行业提供解决方案。立即联络我们',
    // t10_mobile:'我们为您的行业提供解决方案。<br />立即联络我们',
    // t11:'立即申请'
  },
  building: {
    t1: "Office Building Solutions",
    t2: "An office building is to provide excellent customer experience",
    t3: `Office buildingis to deliver a great customer experience, and that's what Chaunve can help with`,
    t3_mobile: `Office buildingis to deliver a great customer experience, and that's what Chaunve can help with`,
    t4: `Chaunve Interactive Dictionary System(IDS) was developed in 2008. Since then, it has been installed in more than 500 public places around the world. It has evolved to the present day, where Chaunve is still in the leading position in interactive dictionary system solutions.In the context of the digital age, customers pay much attention to time and efficiency. They want to get the right information quickly and directly. Interactive Dictionary System is the answer to the needs.With just a few touches, the customer can get the desired direction information.Office buildingspay much attention to design, and the Interactive Dictionary System is the perfect solution. With sleek hardware designs and clear digital displays, Chaunve's products can help to transform any space into a modern and advanced environment.`,
    t4_mobile: `ChaunveInteractive Dictionary System(IDS) was developed in 2008. Since then, it has been installed in more than 500 public places around the world. It has evolved to the present day, where Chaunve is still in the leading position in interactive dictionary system solutions.In the context of the digital age, customers pay much attention to time and efficiency. They want to get the right information quickly and directly. Interactive Dictionary System is the answer to the needs.With just a few touches, the customer can get the desired direction information.Office buildingspay much attention to design, and the Interactive Dictionary System is the perfect solution. With sleek hardware designs and clear digital displays, Chaunve's products can help to transform any space into a modern and advanced environment.`,
    // t5:'创互创造性发明了2D/3D室内地图，拥有”2D/3D地图的显示及指引或导航方法” 的国家发明专利技术，通过登陆后进行铺位的更新 、拆分和合并，打造企业“一张图”服务，可给不同的业务系统调用，结合成熟的导航技术，如蓝牙, WIFI,AR等可实现室内定位导航服务，产品广泛应用在人工智能、大数据、云计算机及物联网等方面。',
    t6: "Smart office",
    t7:
      "Office buildings have complex structure with several floors. Elevator transfer is always confusing. Every day, there will be many new visitors, who need to find their desired destination in the building.Chaunve’s products can simplify this process and provide clear and accurate direction with 3D map technology for visitors.",
    t8: "Office Solutions",
    t9:
      "In addition to the Interactive Dictionary System, we have developed a number of other solutions for office buildings, including:"
    // t10:'我们为您的行业提供解决方案。立即联络我们',
    // t10_mobile:'我们为您的行业提供解决方案。<br />立即联络我们',
    // t11:'立即申请'
  },
  traffic: {
    t1: "Transportation Hub Solutions",
    t2: "Transportation hub is to provide excellent customer experience",
    t3: `Transportation hub is to deliver a great customer experience, and that's what Chaunve can help with`,
    t3_mobile: `Transportation hub is to deliver a great customer experience, and that's what Chaunve can help with`,
    t4: `Chaunve Interactive Dictionary System(IDS) was developed in 2008. Since then, it has been installed in more than 500 public places around the world. It has evolved to the present day, where Chaunve is still in the leading position in interactive dictionary system solutions.In the context of the digital age, customers pay much attention to time and efficiency. They want to get the right information quickly and directly. Interactive Dictionary System is the answer to the needs.With just a few touches, the customer can get the desired direction information.Transportation hubpay much attention to design, and the Interactive Dictionary System is the perfect solution. With sleek hardware designs and clear digital displays, Chaunve's products can help to transform any space into a modern and advanced environment. `,
    t4_mobile: `ChaunveInteractive Dictionary System(IDS) was developed in 2008. Since then, it has been installed in more than 500 public places around the world. It has evolved to the present day, where Chaunve is still in the leading position in interactive dictionary system solutions.In the context of the digital age, customers pay much attention to time and efficiency. They want to get the right information quickly and directly. Interactive Dictionary System is the answer to the needs.With just a few touches, the customer can get the desired direction information.Transportation hubpay much attention to design, and the Interactive Dictionary System is the perfect solution. With sleek hardware designs and clear digital displays, Chaunve's products can help to transform any space into a modern and advanced environment.
  `,
    // t5:'创互创造性发明了2D/3D室内地图，拥有”2D/3D地图的显示及指引或导航方法” 的国家发明专利技术，通过登陆后进行铺位的更新 、拆分和合并，打造企业“一张图”服务，可给不同的业务系统调用，结合成熟的导航技术，如蓝牙, WIFI,AR等可实现室内定位导航服务，产品广泛应用在人工智能、大数据、云计算机及物联网等方面。',
    t6: "Intelligent transportation hub",
    t7: `Transportation hub located in the urban core point of the city, such as airport, high-speed railway station, subway station, pier and so on, have become important public facilities in every city, carrying the city's dreams. Convenient transportation is one of the most important pursuits of urban development. With the increase of population density, the transportation transfer point is getting busier and busier.
  As a result, these places are often complex and difficult to navigate, making it difficult for visitors to know what is available, let alone to find a destination.
  Through advanced technologies such as indoor map, indoor positioning and big data analysis, Chaunve provides clear and accurate direction guidance, which greatly improves the image of the city.`,
    t8: "Transportation solutions",
    t9:
      "In addition to the Interactive Dictionary System, we have developed a number of other solutions for office buildings, including:"
    // t10:'我们为您的行业提供解决方案。立即联络我们',
    // t10_mobile:'我们为您的行业提供解决方案。<br />立即联络我们',
    // t11:'立即申请'
  },
  edu: {
    t1: "School solutions",
    t2: "School is to provide excellent customer experience",
    t3: `The campus is to deliver a great customer experience, and that's what Chaunve can help with.`,
    t3_mobile: `The campus is to deliver a great customer experience, and that's what Chaunve can help with.`,
    t4: `Chaunve Interactive Dictionary System(IDS) was developed in 2008. Since then, it has been installed in more than 500 public places around the world. It has evolved to the present day, where Chaunve is still in the leading position in interactive dictionary system solutions.In the context of the digital age, customers pay much attention to time and efficiency. They want to get the right information quickly and directly. Interactive Dictionary System is the answer to the needs.With just a few touches, the customer can get the desired direction information.Schoolspay much attention to design, and the Interactive Dictionary System is the perfect solution. With sleek hardware designs and clear digital displays, Chaunve's products can help to transform any space into a modern and advanced environment.`,
    t4_mobile: `ChaunveInteractive Dictionary System(IDS) was developed in 2008. Since then, it has been installed in more than 500 public places around the world. It has evolved to the present day, where Chaunve is still in the leading position in interactive dictionary system solutions.In the context of the digital age, customers pay much attention to time and efficiency. They want to get the right information quickly and directly. Interactive Dictionary System is the answer to the needs.With just a few touches, the customer can get the desired direction information.
  Schoolspay much attention to design, and the Interactive Dictionary System is the perfect solution. With sleek hardware designs and clear digital displays, Chaunve's products can help to transform any space into a modern and advanced environment.`,
    // t5:'创互创造性发明了2D/3D室内地图，拥有”2D/3D地图的显示及指引或导航方法” 的国家发明专利技术，通过登陆后进行铺位的更新 、拆分和合并，打造企业“一张图”服务，可给不同的业务系统调用，结合成熟的导航技术，如蓝牙, WIFI,AR等可实现室内定位导航服务，产品广泛应用在人工智能、大数据、云计算机及物联网等方面。',
    t6: "Smart campus",
    t7:
      "By constructing a campus map as the coordinate, the whole campus can be visualized to provide users with 2D/3D map, navigation, welcome message and other convenient services.By combining with the school management system, the system provides 3D indoor map navigation, which can run on the all-in-one facility and WeChat platform. The system can customize the planning navigation route, provide short distance navigation route, and support the navigation across buildings/floors in the campus. Campus map combines GPS (outdoor) + Bluetooth (indoor) positioning technology to realize real-time navigation and positioning.",
    t8: "Campus Solutions",
    t9:
      "In addition to the Interactive Dictionary System, we have developed a number of other solutions for office buildings, including:"
    // t10:'我们为您的行业提供解决方案。立即联络我们',
    // t10_mobile:'我们为您的行业提供解决方案。<br />立即联络我们',
    // t11:'立即申请'
  },
  about: {
    t1: "Chaunve: bring values to our clients",
    t2:
      "We uphold the principle to bring values to our customers alongside the company's development.<br> We strive to bring values to our customers with our services.",
    t2_mobile:
      "We uphold the principle to bring values to our customers alongside the company's development. We strive to bring values to our customers with our services.",
    t3: "Company introduction",
    t4: `Chaunve was founded in 2007 with national patent of "2D/3D map display, directory and navigation methods". We are focused on map related capabilities to facilitate the digitalization of infrastructure and help client to digitalize their space experience. Our featured products are specialized in applications of maps in AI, big data, cloud calculating and the internet of things. Leveraging on the state of art technology and capability of the intellectual properties of indoor maps. A series of products were developed: CMAPPAX, ONE MAP, interactive directory, Static Directory System, Multimedia Information Display System (MIDS), Car Search Payment System (CSPS), easy2walk, easylease, etc. The products are widely used in large scale public facilities including shopping malls, airports, office buildings, hospitals.
  Chaunve's mission is to connect people and the space and also build up the connections between things with the target to be the best indoor map solution provider. Chaunve is a data company, a corporation in the field of "internet of things". With our efforts and capabilities, we aim to connect all people and industries to build a new era of digital world. `,
    t4_mobile: `Chaunve was founded in 2007 with national patent of "2D/3D map display, directory and navigation methods". We are focused on map related capabilities to facilitate the digitalization of infrastructure and help client to digitalize their space experience. Our featured products are specialized in applications of maps in AI, big data, cloud calculating and the internet of things. Leveraging on the state of art technology and capability of the intellectual properties of indoor maps. A series of products were developed: CMAPPAX, ONE MAP, interactive directory, Static Directory System, Multimedia Information Display System (MIDS), Car Search Payment System (CSPS), easy2walk, easylease, etc. The products are widely used in large scale public facilities including shopping malls, airports, office buildings, hospitals.
  Chaunve's mission is to connect people and the space and also build up the connections between things with the target to be the best indoor map solution provider. Chaunve is a data company, a corporation in the field of "internet of things". With our efforts and capabilities, we aim to connect all people and industries to build a new era of digital world. `,
    t5: `Chaunve's "the first" achievements`,
    t6:
      "-	The first company to produce 42 inch high-resolution display with touch screen;",
    t7: `-	The first company to define "Interactive Directory System" for malls;`,
    t8:
      '-	The inventor of "2D/3D map display, directory and navigation methods" (PRC Patent ID: 201310272792.3);',
    t9:
      '-	The first map drawing software "cmappax" with full intellectual property in China;',
    t10: '-	The first business intelligence system based on map data "one map";',
    t11: "Company culture",
    t12: "Our mission",
    t13:
      "Serve more people, benefit more industries and facilitate <br> social  development with our capabilities and services",
    t14: "Our vision",
    t15: "Become the pride of the industry,<br> nation and society",
    t16: "Our values",
    t17: "Honesty, innovation, client first,<br> teamwork, extreme pursue",
    t18: "Our business philosophy",
    t19: "Benefit the ones near and <br> the ones afar will come.",
    t20: "contact us",
    fontList: [
      { value: "May 2020: Chaunve launched OS plan", diFlag: true },
      { value: "May 2020: IDS platform launched" },
      {
        value: "May 2020: Chongqing and Shanghai branches of Gongzhi Committee"
      },
      {
        value:
          "April 2020: Global co-work platform led by Chaunve Gongzhi Committee founded"
      },

      { value: "Mar 2020: indoor map tool software cmappax launched" },
      { value: "Dec 2019: easy2walk launched", diFlag: true },
      {
        value:
          "Nov 2019: Chuanve worked with Haikang to build intelligent surveillance system"
      },

      {
        value:
          "Sep 2019: Chuanve signed contract with Beijing landmark project Chinese Zun"
      },
      { value: "May 2019: Chaunve Medical Industry Department founded" },
      {
        value:
          "Feb 2019: Chaunve signed strategic partnership with Harbour City, Time Square and Hollywood Plaza of Wharf Group"
      },
      { value: "Jan 2019: Chaunve Beijing Branch founded" },
      { value: "Nov 2018: Chaunve Wuhan R&D founded", diFlag: true },
      { value: "Nov 2018: Chaunve Wuhan R&D founded" },
      {
        value:
          "Sep 2018: Chuanve signed contract with Tencent Headquarter for meeting room system "
      },

      {
        value:
          "Aug 2018: Chuanve collaboration with Hysan Group's shopping malls"
      },
      { value: "May 2018: Changsha IFS of Wharf Group launched" },
      {
        value:
          "Sep 2017: Collaboration with Changsha IFS of Wharf Group for integrated digitalized system",
        diFlag: true
      },
      { value: "Aug 2017: one map platform launched" },

      { value: "Jun 2017: digitalization integration strategy announced" },
      { value: "May 2017: Headquarter relocated to office of over 1,000 sqm" },
      { value: "Jan 2017: cloud base strategy announced" },
      {
        value:
          "May 2016: Chaunve joined ICSC in Les Vegas as the only technology company",
        diFlag: true
      },
      { value: "April 2016: Chuanve entered oversea market" },
      { value: "Mar 2016: Chuanve delivered over 200 shopping mall projects" },

      { value: "Aug 2015: Chuanve partnered with Tianhong" },
      {
        value: "Mar 2015: Chuanve partnered with Huadi",
        diFlag: true
      },
      {
        value:
          'Aug 2011: Chuanve recognized as "national high-tech company" in China'
      },
      {
        value: `May 2011: Chaunve obtained "2D/3D map display, directory and navigation methods"patent`
      },
      {
        value: `Mar 2011: Chaunve joined China Mobile "Lifestyle" program`,
        diFlag: true
      },
      {
        value: `Sep 2010: first "mall directory system" lanched in KK Mall in Shenzhen`
      },
      { value: "Mar 2010: first map editing software in the industry" },
      { value: `Jan 2010: obtained "double soft certification"`, diFlag: true },
      {
        value: `Aug 2009: obtained "large screen high resolution display with touch screen" patent`,
        diFlag: true
      },
      {
        value:
          "Aug 2008: developed first 42 inch high resolution display with touch screen",
        diFlag: true
      },
      { value: "July 2007: Chaunve founded", diFlag: true }
    ],
    listData3: [
      {
        url: "./static/window/about/list3_image1.png",
        url1: "./static/mobile/about/1.png",
        title: "Shenzhen | Headquarters",
        des:
          "building116,LuohuhitechIndustrialParkNo.1,<br>Liantang,LuohuDistrict,Shenzhen,China"
      },
      {
        url: "./static/window/about/list3_image2.png",
        url1: "./static/mobile/about/2.png",
        title: "Wuhan",
        des:
          "304, Building 4, Baiyue, Joy City, No. 718 Gaoxin Avenue, Hongshan District, Wuhan"
      },
      {
        url: "./static/window/about/list3_image3.png",
        url1: "./static/mobile/about/3.png",
        title: "Beijing",
        des:
          "room2_206,building5,Shidaifortuneworld,<br>HangfengRoad,FengtaiDistrict,Beijing,China"
      }
    ],
    listData4: [
      {
        url: "./static/window/about/list4_icon1.svg",
        title: "Telephone",
        des: "400-8337-228"
      },
      {
        url: "./static/window/about/list4_icon2.svg",
        title: "mailbox",
        des: "sw@chaunve.com"
      }
    ]
  },
  header: {
    t1: "Interactive Directory <br> System (IDS)",
    t2: "Static Directory <br> System (SDS)",
    t3: "Multimedia Information <br> Display  System (MIDS)",
    t4: "Car Search Payment <br> System (CSPS)",
    t5: "Indoor Navigation <br> System (INS)",
    t6: "AR Navigation <br> System (AR)",
    t7: "Easy2walk",
    t8: "Easylease",
    t9: "Business<br> Intelligence System (BI)",
    t10: "Advertising space<br>management(ADS)",
    t11: "Operation maintenance<br> monitor CKIOSK M1",
    t12: "Self service machine<br> CKIOSK C1",
    t13: "Self service machine<br> CKIOSK C2",
    t14: "Self service machine<br> CKIOSK D1"
  },
  footer: {
    t1: "Improve user experience,from now on!",
    t2: "Welcome to contact us",
    t3: "Headquarters(Shenzhen)",
    t4:
      "address:6/F,building116,LuohuhitechIndustrialParkNo.1,Liantang,LuohuDistrict,Shenzhen,China",
    t5: "WuhanBranch",
    t6:
      "address:304, Building 4, Baiyue, Joy City, No. 718 Gaoxin Avenue, Hongshan District, Wuhan",
    t7: "BeijingBranch",
    t8:
      "address:room2_206,building5,Shidaifortuneworld,HangfengRoad,FengtaiDistrict,Beijing,China"
  },
  messageboard: {
    t1: "Contact with chaunve solutions",
    t2: "Send us a message",
    t3: "*contacts",
    t4: "*mobile phone",
    t5: "*mailbox",
    t6: "*Company or organization",
    t7: "*industry",
    t8: "*department",
    t9: "*Consulting products",
    t10: "Submit",
    t11: "Tips",
    t12: "Thank you. We will contact you as soon as possible",
    t13: "confirm",
    t14: "xPlease enter contact name",
    t15: "xPlease enter your mobile phone number",
    t16: "xPlease enter the correct mobile phone number",
    t17: "xPlease enter the correct mobile phone number",
    t18: "xPlease enter email address",
    t19: "xPlease enter the correct email address",
    t20: "xPlease enter company and organization",
    t21: "xPlease select the industry",
    t22: "xPlease select Department",
    t23: "xPlease select the product you want to consult",
    departmentList: [
      { lable: "Brand retail", value: "品牌零售" },
      { lable: "Store operation", value: "商场营运" },
      { lable: "Electronic Commerce", value: "电子商务" },
      { lable: "Health care", value: "医疗健康" },
      { lable: "Educational groups", value: "教育团体" },
      { lable: "Community life", value: "社区生活" },
      { lable: "Office building", value: "办公大楼" },
      { lable: "software development", value: "软件开发" },
      { lable: "Online media", value: "在线媒体" },
      { lable: "other", value: "其他" }
    ],
    industryList: [
      { lable: "Shopping Mall", value: "购物中心" },
      { lable: "Hospital", value: "医院" },
      { lable: "Education", value: "教育" },
      { lable: "Traffic", value: "交通" },
      { lable: "Office Building", value: "写字楼" },
      { lable: "other", value: "其他" }
    ],
    productList: [
      { lable: "one map", value: "one map" },
      { lable: "Interactive Directory System (IDS)", value: "互动指南系统" },
      { lable: "Static Directory System (SDS)", value: "静态指南系统" },
      {
        lable: "Multimedia Information Display System (MIDS)",
        value: "多媒体信息发布系统"
      },
      { lable: "Car Search Payment System (CSPS)", value: "自助寻车缴费系统" },
      { lable: "Indoor Navigation System (INS)", value: "室内导航系统" },
      { lable: "AR Navigation System (AR)", value: "AR导航系统" },
      { lable: "Easylease", value: "云招商" },
      { lable: "Easy2walk", value: "路易寻" },
      { lable: "other", value: "其他" }
    ]
  },
  bi: {
    t1: 'Business Intelligence System (BI)',
    t2: 'Data is in your hands',
    t3: 'Business Intelligence System, All data is in your hands',
    t4: `With the diversification of business development and the fierce competition industry, how to improve the operation and management of shopping malls and increase economic efficiency is very important for the entire shopping malls. The traditional management of shopping mall shops is mainly managed in the form of tables.
    However, it is generally difficult for forms to accurately and intuitively display information such as the change status of stores in shopping malls, such as rent arrears of the shops, commodity operation status, etc. If a change in the shop, the records need to be continuously updated. Such a management not only maintain.
    The workload is large and the efficiency is low, which is not convenient for retrieval, and restricts the management of the entire shopping malls and the utilization efficiency of shops.`,
    t20: 'In different platforms, you can view the data anytime, anywhere',
    t21: `Not restricted by geographic platform, allowing you to view data instantly anytime, anywhere<br>
    Developed in HTML5，Data of updated in seconds, and you can immediately notice the latest situation on the spot, and can be 
    viewed on different platforms at the same time, regardless of the geographical platform.<br>
    The indoor map is displayed and the user can simple and direct to select the data in the map and view. <br>
    The Business Intelligence System can relevant personnel assisted in manual operation while performing correlation analysis of 
    data, and produced different analysis charts to fully display the process of data analysis and different data trends. 。`,
    t5: 'computer',
    t6: 'mobile',
    t7: 'Key Features',
    t8: 'Income warning',
    t9: 'Make reasonable analysis and judgments based on the income of the shops, and make effective adjustments to the distribution and operating conditions of each floor or trade mix.',
    t10: 'Rental Situation',
    t11: 'The shop rental situation displayed in a visual manner to provide data support for the leasing decision, so as to quickly investigate and deal with the problem of shop rental.',
    t12: 'Sales Analysis',
    t13: `Intelligently count the floor efficiency data of the whole mall and the shops, and display them in the form.
    You can see the development trend of sales more intuitively and clearly, combined with the sales performance of the shop
    The comparison of real-time understanding sales of different brand.`,
    t14: 'Rent Management',
    t15: 'Automatically to count the outstanding rent and the number of days overdue, easily to understand the rent situation, adjust the rent of the shop through the rent ratio, and ensure the normal operation of the shop.',
    t16: 'Traffic statistics',
    t17: 'Using high-precision data on the Traffic statistics to effective marketing and promotion, to provide rich and accurate customer information, help the mall to negotiate leases with merchants based on actual data, guide operations, and achieve refined operations. Improve management efficiency and reduce operating costs.    ',
    t18: 'Delegation Management',
    t19: 'For confidentiality and business needs, The system supports user delegation management control, Supports control of different users’ permissions on data package, permission setting based on access control list and role control, Realise the big data environment Access control at the database system level. ',
  },
  ads: {
    t1: 'Advertisement Management System (ADS)',
    t2: 'Full picture digital advertising resource ',
    t3: 'Build a full-scene advertising map and Advertising management and online appointment',
    t4: 'Based on the map Technology of Chaunve, it builds a map of advertising space based on location distribution to realize online management, appointment, and approval to helps shopping mall advertising operations. Compared with the EXCEL to manage, the advertising space map breaks through the static, complicated, and untimely update problems, and shapes the three-dimensional display form that integrates location, real scene, and orientation. In addition, it is screened by multi-dimensional conditions such as distribution area and advertising schedule. Improved the ease of operation and enhanced advertisers’ booking intentions.',
    t5: 'Features',
    t6: 'Advertising management ',
    t7: 'Double-click on the map to accurately create advertising spots, and pass the advertising category-single spot Two-level management mode to realize batch management',
    t8: 'The advertising space map supports zooming and dragging to view the advertising distribution and point details of each location',
    t9: 'Smart Schedule',
    t10: 'Full picture to see Booking, scheduling, release, released brand',
    t11: 'Calendar to present of free time points and conflict-free appointments',
    t12: 'Appointment and approval',
    t13: 'Advertisers',
    t14: 'based on time to choose advertising point',
    t15: 'based on location to choose advertising point',
    t16: 'Operator',
    t17: 'Online approval anytime, anywhere, and realtime to feedback of approval status',
    t18: 'Support multi-level approval, track approval progress',
    t19: 'Reports',
    t20: 'Statistics from the dimensions of advertising space resource distribution, lease status, etc., to facilitate operators to understand the resource status in time',
    t21: 'Statistics from dimensions such as the number of reservation applications and advertisers’ formats provide data basis for operators to plan and adjust advertising spaces',
    t22: 'Statistics from dimensions such as the time and space distribution of scheduled advertisements to reduce the difficulty of advertisers’ decision-making',
  }
};



// WEBPACK FOOTER //
// ./src/common/lang/en.js